export default __webpack_public_path__ + "static/media/3-mini.93687eb6.webp";